import { render, staticRenderFns } from "./JcReportDetail.vue?vue&type=template&id=b3df2b52&"
import script from "./JcReportDetail.vue?vue&type=script&lang=js&"
export * from "./JcReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./JcReportDetail.vue?vue&type=style&index=0&id=b3df2b52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports